import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aoh-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.scss']
})
export class CompleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
